export default {
    SET_PAYMENTS: (state, payments) => {
        state.payments = payments
    },

    SET_PAGINATION: (state, pagination) => {
        state.pagination = pagination
    },

    SET_LOAD: (state, isLoaded) => {
        state.isLoaded = isLoaded
    },

    SET_FILTERS: (state, filters) => {
        state.filters = filters
    },

    RESET_PAYMENTS: (state) => {
        state.filters = {
            phoneNumber: null,
            taxiOrderId: null,
            clientId: null,
            orderId: null,
            fromDate: new Date(+new Date() - 604800000).toISOString().split('T')[0],
            toDate: new Date().toISOString().split('T')[0],
            type: null,
            status: null
        }
    }
}
